import {Injectable} from '@angular/core';
import { Settings } from '../../../editor-tools/core/config/settings.service';
import * as WebFont from 'webfontloader';
import {FontsPaginatorService} from './fonts-paginator.service';
import {map} from 'rxjs/operators';
import { HttpCacheClient } from '../../../editor-tools/core/http/http-cache-client';
import {FontItem} from './font-item';

@Injectable()
export class GoogleFontsPanelService {

    private loadedFonts: FontItem[] = [];

    private customFonts: FontItem[] = [];

    /**
     * GoogleFontsPanelService Constructor.
     */
    constructor(
        private http: HttpCacheClient,
        private settings: Settings,
        public paginator: FontsPaginatorService,
    ) {
        this.paginator.current$.subscribe(fonts => {
            this.loadIntoDom(fonts);
        });

        this.customFonts = this.settings.get('pixie.tools.text.items', []);
    }

    public async init() {
        let fonts = this.customFonts.slice();

        if ( ! this.settings.get('pixie.tools.text.replaceDefault')) {
            fonts = fonts.concat(await this.getGoogleFonts());
        }

        this.paginator.setFonts(fonts);
    }

    /**
     * Load specified google fonts into the DOM.
     */
    public loadIntoDom(names: FontItem[] = [], context?: Window): Promise<any> {
        return new Promise(resolve => {
            //remove already loaded fonts
            names = names.filter(curr => !this.loadedFonts.find(font => font.family === curr.family));
            if ( ! names.length) return resolve(null);
            this.loadedFonts = this.loadedFonts.concat(names);

            const google = names.filter(font => font.type === 'google');
            const custom = names.filter(font => font.type === 'custom');

            const config = {
                active: resolve,
                context: context as any,
                classes: false,
            };

            if (google.length) {
                config['google'] = {families: google.map(font => font.family)};
            }

            if (custom.length) {
                this.loadCustomFonts(custom, context);
                config['custom'] = {families: custom.map(font => font.family)};
            }

            WebFont.load(config);
        });
    }

    /**
     * Load custom fonts via font-face css property.
     */
    private loadCustomFonts(fonts: FontItem[] = [], context?: Window) {
        if ( ! fonts.length) return;
        let style = '';

        fonts.forEach(font => {
            const url = this.settings.getAssetUrl('fonts') + font.filePath;
            style += '@font-face { font-family: '+font.family+'; src: url("'+url+'"); }';
        });

        const styleEl = document.createElement('style');
        styleEl.innerHTML = style;
        (context || window).document.head.appendChild(styleEl);
    }

    /**
     * Get list of all google fonts.
     */
    private getGoogleFonts(): Promise<FontItem[]> {
        const key = this.settings.get('pixie.googleFontsApiKey');

        //TODO: fix the type issues here sometime
        return this.http.getWithCache('https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key='+key)
            .pipe(map(response => {
                return response['items'].map(font => {
                    return {family: font.family, category: font.category, type: 'google'};
                });
            }) as any).toPromise() as any;
    }
}
